import { useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { SERVICES } from "@/lib/content";

export default function Services() {
  const [active, setActive] = useState(null);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const wrapRef = useRef(null);

  const onMove = (e) => {
    setPos({ x: e.clientX, y: e.clientY });
  };

  return (
    <section
      id="services"
      className="relative bg-[color:var(--te-surface)] px-5 md:px-10 py-24 md:py-32 border-t border-white/10"
      onMouseMove={onMove}
      ref={wrapRef}
      data-testid="services-section"
    >
      <div className="max-w-[1440px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14 md:mb-20">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-2 h-2 bg-[color:var(--te-primary)] rotate-45" />
              <span className="text-[11px] uppercase tracking-[0.28em] text-[color:var(--te-primary)] font-display">
                Capabilities
              </span>
            </div>
            <h2
              className="font-display font-black uppercase text-white tracking-tighter leading-[0.9]"
              style={{ fontSize: "clamp(2.4rem, 6vw, 5.5rem)" }}
              data-testid="services-heading"
            >
              Everything below <br />
              <span className="font-serif-italic tracking-normal text-[color:var(--te-primary)]">
                the surface.
              </span>
            </h2>
          </div>
          <p className="max-w-md text-white/60 font-body text-base md:text-lg leading-relaxed">
            Kerb &amp; channel, stormwater management and concrete lead our work — backed by seven more services covering every stage of civil and earthmoving in Central Queensland.
          </p>
        </div>

        <ul className="border-t border-white/10">
          {SERVICES.map((s, i) => (
            <li
              key={s.key}
              onMouseEnter={() => setActive(i)}
              onMouseLeave={() => setActive(null)}
              className="group relative border-b border-white/10"
              data-testid={`service-row-${s.key}`}
            >
              <button
                onClick={() => document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" })}
                className="w-full flex items-center justify-between py-6 md:py-8 text-left transition-colors"
              >
                <div className="flex items-baseline gap-4 md:gap-8">
                  <span className="text-[11px] md:text-xs uppercase tracking-[0.28em] text-white/40 font-display w-8">
                    0{i + 1}
                  </span>
                  <span
                    className="font-display font-black uppercase tracking-tight text-white group-hover:text-[color:var(--te-primary)] transition-colors leading-none"
                    style={{ fontSize: "clamp(1.75rem, 4vw, 3.4rem)" }}
                  >
                    {s.name}
                  </span>
                </div>
                <div className="hidden md:flex items-center gap-6">
                  <span className="text-sm text-white/50 font-body max-w-[280px] text-right hidden lg:block">
                    {s.blurb}
                  </span>
                  <span className="text-2xl text-white/60 group-hover:text-[color:var(--te-primary)] group-hover:translate-x-2 transition-all">
                    →
                  </span>
                </div>
              </button>
            </li>
          ))}
        </ul>
      </div>

      {/* Spotlight image following cursor */}
      <AnimatePresence>
        {active !== null && (
          <motion.img
            key={SERVICES[active].key}
            src={SERVICES[active].img}
            alt={SERVICES[active].name}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="spotlight-img on"
            style={{ left: pos.x, top: pos.y }}
            data-testid="services-spotlight"
          />
        )}
      </AnimatePresence>
    </section>
  );
}
